/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone} from '@angular/core';
import template from './email-template-edit-page.component.html';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import {AdminResourceEditPageBase} from '../../common/controller/admin-resource-edit-page-base';
import {TeamResource} from '../../../components/api/resources/resource/team.resource';
import {
  applyDefaultEmailTemplateContent,
  getEmailTemplateTeamQueryParams,
  initEmailTemplateModel,
  prepareEmailTemplateForSubmit,
  updateEmailTemplateInfo
} from './email-template-commons';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-email-template-edit-page',
  template
})
export class EmailTemplateEditPageComponent extends AdminResourceEditPageBase {
  isMarketplace = false;
  allTeams: any[] = [];
  teamsLoaded = false;

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserPermissions) private LocalUserPermissions: any,
    @Inject(TeamResource) private Team: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
    this.isMarketplace = LocalNetworkProfile.isPureMarketplacePlatform();
    this.loadTeams();
  }

  get showTeamField(): boolean {
    return this.isMarketplace || !!this.editingModel?.team?.id;
  }

  compareTeams(team1: any, team2: any): boolean {
    return team1 && team2 ? team1.id === team2.id : team1 === team2;
  }

  onTypeChange(): void {
    applyDefaultEmailTemplateContent(this.editingModel);
  }

  onSpecifyEmailTemplateChange(): void {
    applyDefaultEmailTemplateContent(this.editingModel);
    this.markExternalFormDirty();
  }

  protected afterInitEditingModel(): void {
    initEmailTemplateModel(this.editingModel);
  }

  protected afterInitAfterSave(): void {
    updateEmailTemplateInfo(this.editingModel);
    applyDefaultEmailTemplateContent(this.editingModel);
  }

  protected onBeforeSubmit(): void {
    prepareEmailTemplateForSubmit(this.editingModel);
  }

  private loadTeams(): void {
    this.Team.query(getEmailTemplateTeamQueryParams(this.LocalUserPermissions)).$promise.then((page: any) => {
      this.allTeams = page.results || [];
      this.teamsLoaded = true;
    });
  }
}
